import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import Blog from "./components/Blog";
import BlogPost from "./components/Blogpost";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/blog" element={<Navigate to="/blog/1" />} />
        <Route path="/blog/:page" element={<Blog />} />
        <Route exact path="/blog/article/:id" element={<BlogPost />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
